// TIBECO - Ferestre și Uși - Sidebar Navigation - Versiune Completă
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  Home,
  Factory,
  Package,
  CheckCircle,
  Settings,
  Calendar,
  Ruler,
  PenTool,
  Calculator,
  BookOpen,
  FileText,
  Wrench,
  MapPin,
  Users,
  TrendingUp,
  ShoppingCart,
  BarChart,
  User,
  Target,
  Network,
  DollarSign,
  CreditCard,
  Receipt,
  X,
  ChevronDown,
  ClipboardList,
  Boxes,
  Truck,
  Phone,
  Star,
  Shield,
  AlertTriangle,
  Eye,
  Globe,
  Mail,
  Zap,
  Brain,
  Bot,
  Plus,
  Cloud,
  Database,
  Server,
  HardDrive,
  Upload,
  Download,
  Video,
  Users2,
  MessageSquare
} from 'lucide-react';

const Sidebar = ({ isOpen, setIsOpen }) => {
  const location = useLocation();

  const tibecoMenuItems = [
    {
      id: 'production',
      name: 'Producție & Fabricație',
      icon: Factory,
      color: 'text-primary-600',
      path: '/production',
      children: [
        { name: 'Dashboard Producție', path: '/production/orders', icon: Home, implemented: true },
        { name: 'Comenzi Fabricație', path: '/production/orders', icon: ClipboardList, implemented: true },
        { name: 'Gestionare Materiale', path: '/production/materials', icon: Package, implemented: true },
        { name: 'Control Calitate', path: '/production/quality', icon: CheckCircle, implemented: true },
        { name: 'Echipamente', path: '/production/equipment', icon: Settings, implemented: true },
        { name: 'Planificare Producție', path: '/production/planning', icon: Calendar, implemented: true }
      ]
    },
    {
      id: 'engineering',
      name: 'Proiectare & Tehnică',
      icon: Ruler,
      color: 'text-accent-blue',
      path: '/engineering',
      children: [
        { name: 'Proiecte Tehnice', path: '/engineering/projects', icon: FileText, implemented: true },
        { name: 'Măsurători Clienți', path: '/engineering/measurements', icon: Ruler, implemented: true },
        { name: 'Desene Tehnice', path: '/engineering/drawings', icon: PenTool, implemented: true },
        { name: 'Calcule Structurale', path: '/engineering/calculations', icon: Calculator, implemented: true },
        { name: 'Biblioteca Standarde', path: '/engineering/standards', icon: BookOpen, implemented: true }
      ]
    },
    {
      id: 'installation',
      name: 'Instalare & Montaj',
      icon: Wrench,
      color: 'text-secondary-600',
      path: '/installation',
      children: [
        { name: 'Programare Montaj', path: '/installation/schedule', icon: Calendar, implemented: true },
        { name: 'Echipe Instalatori', path: '/installation/teams', icon: Users, implemented: true },
        { name: 'Urmărire GPS Live', path: '/installation/tracking', icon: MapPin, implemented: true },
        { name: 'Unelte & Echipamente', path: '/installation/tools', icon: Wrench, implemented: true },
        { name: 'Rapoarte Montaj', path: '/installation/reports', icon: FileText, implemented: true }
      ]
    },
    {
      id: 'sales',
      name: 'Vânzări & CRM',
      icon: TrendingUp,
      color: 'text-purple-600',
      path: '/sales',
      children: [
        { name: 'Dashboard Vânzări', path: '/sales/dashboard', icon: BarChart, implemented: true },
        { name: 'Calculator Preț', path: '/sales/calculator', icon: Calculator, implemented: true },
        { name: 'Baza de Clienți', path: '/sales/clients', icon: Users, implemented: true },
        { name: 'Analize Vânzări', path: '/sales/analytics', icon: TrendingUp, implemented: true },
        { name: 'Istoric Comenzi', path: '/sales/orders', icon: ClipboardList, implemented: true },
        { name: 'Integrare Logistică', path: '/sales/logistics', icon: Truck, implemented: true },
        { name: 'Optimizare Stocuri', path: '/sales/inventory-opt', icon: Package, implemented: true },
        { name: 'Previziuni Vânzări', path: '/sales/forecasting', icon: Brain, implemented: true },
        { name: 'Raportare Automată', path: '/sales/reports', icon: FileText, implemented: true }
      ]
    },
    {
      id: 'inventory',
      name: 'Stocuri & Logistică',
      icon: Package,
      color: 'text-indigo-600',
      path: '/inventory',
      children: [
        { name: 'Dashboard Stocuri', path: '/inventory/dashboard', icon: BarChart, implemented: true },
        { name: 'Profile PVC/Aluminiu', path: '/inventory/profiles', icon: Package, implemented: true },
        { name: 'Stocuri Sticlă', path: '/inventory/glass', icon: Boxes, implemented: true },
        { name: 'Feronerie & Accesorii', path: '/inventory/hardware', icon: Settings, implemented: true },
        { name: 'Managementul Furnizorilor', path: '/inventory/suppliers', icon: Truck, implemented: true },
        { name: 'Aprovizionare', path: '/inventory/procurement', icon: ShoppingCart, implemented: true }
      ]
    },
    {
      id: 'hr',
      name: 'Resurse Umane',
      icon: Users,
      color: 'text-primary-600',
      path: '/hr',
      children: [
        { name: 'Portal Angajați', path: '/hr/portal', icon: User, implemented: true },
        { name: 'Planificator Concedii', path: '/hr/vacations', icon: Calendar, implemented: true },
        { name: 'Evaluări Performanță', path: '/hr/performance', icon: Target, implemented: true },
        { name: 'Platformă E-learning', path: '/hr/elearning', icon: BookOpen, implemented: true },
        { name: 'Organigrama Digitală', path: '/hr/organigram', icon: Network, implemented: true },
        { name: 'Documente HR', path: '/hr/documents', icon: FileText, implemented: true },
        { name: 'Gestionare CV-uri', path: '/hr/cv-management', icon: User, implemented: true }
      ]
    },
    {
      id: 'accounting',
      name: 'Financiar & Contabilitate',
      icon: DollarSign,
      color: 'text-yellow-600',
      path: '/accounting',
      children: [
        { name: 'Facturi Clienți', path: '/accounting/invoices', icon: Receipt, implemented: true },
        { name: 'Cheltuieli Operaționale', path: '/accounting/expenses', icon: CreditCard, implemented: true },
        { name: 'Plăți & Încasări', path: '/accounting/payments', icon: DollarSign, implemented: true },
        { name: 'Urmărire Plăți', path: '/accounting/payment-tracking', icon: Eye, implemented: true },
        { name: 'Rapoarte Financiare', path: '/accounting/reports', icon: BarChart, implemented: true },
        { name: 'Verificare Discrepanțe', path: '/accounting/discrepancies', icon: AlertTriangle, implemented: true },
        { name: 'Management Documente', path: '/accounting/documents', icon: FileText, implemented: true },
        { name: 'Emitere Facturi', path: '/accounting/invoice-generation', icon: FileText, implemented: true },
        { name: 'Migrare Date', path: '/accounting/data-migration', icon: Zap, implemented: true },
        { name: 'SmartBill', path: 'https://www.smartbill.ro', icon: Zap, implemented: true },
        { name: 'Integrare Office 365', path: '/accounting/office365', icon: Globe, implemented: true }
      ]
    },
    {
      id: 'crm',
      name: 'CRM & Automatizare',
      icon: Bot,
      color: 'text-blue-600',
      path: '/crm',
      children: [
        { name: 'CRM Complet', path: '/crm/complete', icon: Users, implemented: true },
        { name: 'Analiză Predictivă', path: '/crm/predictive', icon: Brain, implemented: true },
        { name: 'Automatizare RPA', path: '/crm/automation', icon: Bot, implemented: true },
        { name: 'Chatbot 24/7', path: '/crm/chatbot', icon: Phone, implemented: true },
        { name: 'Integrare WhatsApp', path: '/crm/whatsapp', icon: Phone, implemented: true }
      ]
    },
    {
      id: 'erp',
      name: 'ERP',
      icon: Settings,
      color: 'text-blue-600',
      path: 'https://erp.aipro.ro/loginTibeco',
      external: true,
      children: []
    },
    {
      id: 'ai-solutions',
      name: 'Soluții AI',
      icon: Brain,
      color: 'text-purple-600',
      path: 'https://davinci.aipro.ro/login2',
      external: true,
      children: []
    },
    {
      id: 'marketing',
      name: 'Marketing & Comunicare',
      icon: Star,
      color: 'text-pink-600',
      path: '/marketing',
      children: [
        { name: 'Campanii Email', path: '/marketing/email', icon: Mail, implemented: true },
        { name: 'Generare Conținut AI', path: '/marketing/content-ai', icon: Brain, implemented: true },
        { name: 'Analiză Performanță', path: '/marketing/analytics', icon: BarChart, implemented: true },
        { name: 'Adaptare la Piață', path: '/marketing/market-adapt', icon: Target, implemented: true },
        { name: 'Website & Portofoliu', path: '/marketing/website', icon: Globe, implemented: true }
      ]
    },
    {
      id: 'security',
      name: 'Securitate & Monitorizare',
      icon: Shield,
      color: 'text-red-600',
      path: '/security',
      children: [
        { name: 'Detectare Amenințări', path: '/security/threats', icon: AlertTriangle, implemented: true },
        { name: 'Monitorizare 24/7', path: '/security/monitoring', icon: Eye, implemented: true },
        { name: 'Raportare Incidente', path: '/security/incidents', icon: FileText, implemented: true },
        { name: 'Răspuns Automatizat', path: '/security/response', icon: Bot, implemented: true }
      ]
    },
    {
      id: 'cloud',
      name: 'Cloud Storage',
      icon: Cloud,
      color: 'text-cyan-600',
      path: '/cloud',
      children: [
        { name: 'Dashboard Cloud', path: '/cloud/dashboard', icon: Database, implemented: true },
        { name: 'Fișiere & Documente', path: '/cloud/files', icon: HardDrive, implemented: true },
        { name: 'Upload Manager', path: '/cloud/upload', icon: Upload, implemented: true },
        { name: 'Backup & Sync', path: '/cloud/backup', icon: Server, implemented: true },
        { name: 'Setări Amazon S3', path: '/cloud/settings', icon: Settings, implemented: true }
      ]
    },
    {
      id: 'integrations',
      name: 'Integrări Office',
      icon: Video,
      color: 'text-indigo-600',
      path: '/integrations',
      children: [
        { name: 'Microsoft 365', path: '/integrations/microsoft365', icon: Mail, implemented: true },
        { name: 'Teams & Calendar', path: '/integrations/teams', icon: Calendar, implemented: true },
        { name: 'Zoom Meetings', path: '/integrations/zoom', icon: Video, implemented: true },
        { name: 'SharePoint', path: '/integrations/sharepoint', icon: HardDrive, implemented: true },
        { name: 'Outlook Integration', path: '/integrations/outlook', icon: Mail, implemented: true }
      ]
    },
    {
      id: 'enterprise',
      name: 'Enterprise & Rapoarte',
      icon: BarChart,
      color: 'text-gray-600',
      path: '/enterprise',
      children: [
        { name: 'Dashboard Executive', path: '/enterprise/dashboard', icon: BarChart, implemented: true },
        { name: 'Rapoarte Avansate', path: '/enterprise/reporting', icon: FileText, implemented: true },
        { name: 'Automatizare Workflow', path: '/enterprise/workflow', icon: Bot, implemented: true },
        { name: 'Overview Enterprise', path: '/enterprise/overview', icon: Globe, implemented: true }
      ]
    }
  ];

  const [expandedItems, setExpandedItems] = React.useState({
    production: true // Implicit expanded pentru producție
  });

  const toggleExpanded = (itemId) => {
    setExpandedItems(prev => ({
      ...prev,
      [itemId]: !prev[itemId]
    }));
  };



  return (
    <>
      {/* Mobile overlay */}
      {isOpen && (
        <div
          className="fixed inset-0 z-20 bg-black/50 backdrop-blur-sm lg:hidden animate-in"
          onClick={() => setIsOpen(false)}
        />
      )}

      {/* Sidebar */}
      <div
        className={`fixed left-0 top-0 z-30 w-80 h-screen bg-white/95 dark:bg-gray-900/95 backdrop-blur-xl shadow-strong transform transition-all duration-300 lg:relative lg:translate-x-0 border-r border-gray-200 dark:border-gray-700 flex flex-col ${
          isOpen ? 'translate-x-0' : '-translate-x-full'
        }`}
      >
        {/* Mobile header */}
        <div className="flex items-center justify-between p-4 sm:p-6 border-b border-gray-200 dark:border-gray-700 lg:hidden flex-shrink-0">
          <div className="flex items-center">
            <Factory className="w-5 h-5 sm:w-6 sm:h-6 text-primary-600 mr-2" />
            <h2 className="text-base sm:text-lg font-semibold text-gray-900 dark:text-white">TIBECO Menu</h2>
          </div>
          <button
            onClick={() => setIsOpen(false)}
            className="p-1.5 sm:p-2 text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 transition-all duration-200"
          >
            <X className="w-4 h-4 sm:w-5 sm:h-5" />
          </button>
        </div>

        {/* Logo and brand */}
        <div className="p-4 sm:p-6 border-b border-gray-200 dark:border-gray-700 flex-shrink-0">
          <div className="flex items-center">
            <div className="flex items-center justify-center rounded-xl mr-3 overflow-hidden" style={{ width: '200px' }}>
             <img 
                src="/assets/logo.png" 
                alt="TIBECO Logo" 
                className="w-full h-full object-contain" 
              />

            </div>
          </div>
        </div>

        {/* Navigation - Scrollable */}
        <div className="flex-1 overflow-y-auto custom-scrollbar">
          <div className="p-3 sm:p-4">
            <nav className="space-y-1 sm:space-y-2">
              {tibecoMenuItems.map((item, index) => {
                const Icon = item.icon;
                const isExpanded = expandedItems[item.id];
                const isActive = location.pathname.startsWith(item.path);

                return (
                  <div key={item.id} className="animate-slide" style={{ animationDelay: `${index * 50}ms` }}>
                    {item.external ? (
                      // External link - no dropdown
                      <a
                        href={item.path}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() => setIsOpen(false)}
                        className={`w-full text-left flex items-center p-3 sm:p-4 rounded-xl transition-all duration-200 group hover:bg-gray-50 dark:hover:bg-gray-800 text-gray-700 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white`}
                      >
                        <div className="flex items-center flex-1 min-w-0">
                          <Icon className={`w-5 h-5 mr-3 flex-shrink-0 ${item.color}`} />
                          <span className="font-medium text-sm sm:text-base truncate">{item.name}</span>
                        </div>
                        <div className="flex items-center gap-2">
                          <Globe className="w-4 h-4 text-gray-400" />
                        </div>
                      </a>
                    ) : (
                      // Internal section with dropdown
                      <>
                        <button
                          onClick={() => toggleExpanded(item.id)}
                          className={`w-full text-left flex items-center p-3 sm:p-4 rounded-xl transition-all duration-200 group hover:bg-gray-50 dark:hover:bg-gray-800 ${
                            isActive 
                              ? 'bg-primary-50 dark:bg-primary-900/50 text-primary-700 dark:text-primary-300 shadow-soft' 
                              : 'text-gray-700 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white'
                          }`}
                        >
                          <div className="flex items-center flex-1 min-w-0">
                            <Icon className={`w-5 h-5 mr-3 flex-shrink-0 ${item.color} ${isActive ? 'text-primary-600 dark:text-primary-400' : ''}`} />
                            <span className="font-medium text-sm sm:text-base truncate">{item.name}</span>
                          </div>
                          <div className="flex items-center gap-2">
                            <span className="text-xs text-gray-400">{item.children.length}</span>
                            <ChevronDown
                              className={`w-4 h-4 transition-transform duration-300 flex-shrink-0 ${
                                isExpanded ? 'rotate-180' : ''
                              }`}
                            />
                          </div>
                        </button>

                        {isExpanded && (
                          <div className="mt-2 ml-6 space-y-1 animate-in">
                            {item.children.map((subItem, subIndex) => {
                              const SubIcon = subItem.icon;
                              return (
                                <Link
                                  key={subIndex}
                                  to={subItem.path}
                                  onClick={() => setIsOpen(false)}
                                  className={`flex items-center justify-between px-4 py-2.5 text-sm rounded-xl transition-all duration-200 ${
                                    location.pathname === subItem.path
                                      ? 'bg-primary-50 dark:bg-primary-900/50 text-primary-700 dark:text-primary-300 font-medium shadow-soft'
                                      : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white hover:bg-gray-50 dark:hover:bg-gray-800'
                                  }`}
                                >
                                  <div className="flex items-center min-w-0">
                                    <SubIcon className="w-4 h-4 mr-3 flex-shrink-0" />
                                    <span className="truncate">{subItem.name}</span>
                                  </div>
                                </Link>
                              );
                            })}
                          </div>
                        )}
                      </>
                    )}
                  </div>
                );
              })}
            </nav>
          </div>
        </div>

        {/* Footer - Fixed at bottom */}
        <div className="flex-shrink-0 p-3 sm:p-4 border-t border-gray-200 dark:border-gray-700">
          <div className="p-3 sm:p-4 bg-gradient-to-r from-red-50 to-purple-50 dark:from-red-900/20 dark:to-purple-900/20 rounded-xl border border-red-200 dark:border-red-800">
            <div className="text-xs text-gray-600 dark:text-gray-400 text-center space-y-1">
              <div className="flex items-center justify-between">
                <span className="font-medium">TIBECO ERP</span>
                <span className="text-red-600 font-bold">v2.0</span>
              </div>
              <p>ferestre-tibeco.ro</p>
              <div className="flex justify-between text-xs">
                <span>11 angajați</span>
                <span>Suceava, România</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Sidebar;